<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.renewal')" :newButShow="true" @newBut="newBut('add')"></pageTitle>
        <myTableFilter @submit="handleSubmit" :show="{ renewal_name: true  }" />
        <myTable ref="table" :columns="columns" requestUrl="renewal/list" :showPage="true">
          <template v-slot:action="{ data }">
            <Icon
              class="cursor_p"
              type="md-create"
              size="24"
              color="#1F8FC8"
              @click="newBut('edit',data.row)"
            />
            <Poptip
              placement="bottom"
              confirm
              :title="$t('confirm_delete')"
              @on-ok="handleDel(data.row)"
            >
              <Icon class="cursor_p mg-left15" type="md-trash" size="24" color="#7D7C7F" />
            </Poptip>
          </template>
        </myTable>
      </div>
    </div>
    <edit
      v-if="modal"
      @onOk="onOk"
      :roleList="list"
      :type="type"
      :modal="modal"
      :itemObj="itemObj"
      @cancel="cancel"
    ></edit>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
import myTableFilter from "@/components/myTableFilter";
import edit from "./module/renewal_edit";
export default {
  name: "baseMtag",
  components: {
    myTable,
    pageTitle,
    myTableFilter,
    edit,
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          key: "renewal_id",
          align: "center",
          width: 100,
        },
        {
          title: this.$t("renewal.name") + "(EN)",
          key: "en_cname",
          align: "center"
        },
        {
          title: this.$t("renewal.name") + "(繁体)",
          key: "zh-tw_cname",
          align: "center"
        },
        {
          title: this.$t("renewal.name") + "(简体)",
          key: "zh-cn_cname",
          align: "center"
        },
        {
          title: this.$t("role_cname"),
          key: "role_cdesc",
          align: "center"
        },
        {
          title: this.$t("yfee_xd"),
          key: "days",
          align: "center"
        },
        {
          title: this.$t("price"),
          key: "price",
          align: "center"
        },
        {
          title: this.$t("Info.order"),
          key: "sort_id",
          align: "center"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action",
          width: 180,
        },
      ],
      modal: false,
      modal2: false,
      itemObj: {},
      type: "add",
      list: []
    };
  },
  created () {
    this.getBeforeList()
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    getBeforeList () {
      this.$base.showLoading;
      this.$request.sendPost(
        "renewal/before-add",
        {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          this.list = data.roles
        }
      );
    },
    newBut (type, item) {
      this.type = type
      this.itemObj = item
      this.modal = true
    },
    cancel () {
      this.modal = false
    },
    onOk () {
      this.$base.msgSuccess(this.$t("op_ok"));
      this.$refs.table.getLoad();
    },
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    handleDel (item) {
      this.$base.showLoading();
      this.$request.sendPost(
        'renewal/del',
        { renewal_id: item.renewal_id },
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.alertErr(error.errmsg);
          this.$base.msgSuccess(this.$t("op_ok"));
          this.$refs.table.getLoad();
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .ivu-icon-ios-help-circle:before {
    content: '';
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    padding-left: 0;
  }
  .ivu-poptip-confirm .ivu-poptip-footer > .ivu-btn {
    padding: 2px 8px;
    font-size: 14px;
  }
  .ivu-poptip-confirm .ivu-poptip-body-message {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/renewal/renewal.vue